import { ThemeInterface } from '@westwing/ui-kit/Theme';
import styled, { ThemeProps } from 'styled-components';
import { fromBreakpoint, MOBILE_MED, TABLET, tillBreakpoint } from '../../../../mediaqueries';
import { Title } from 'SharedComponents/styled/overlay/Title';

interface LogoProps extends ThemeProps<ThemeInterface> {
    isDefaultLogo: boolean;
    extraPadding?: boolean;
}
export const Logo = styled.img<LogoProps>`
    display: block;
    max-width: 182px;
    margin: 0 auto;
    ${(props: LogoProps) => (props.extraPadding ? 'margin: 30px auto 50px;' : '')}
    & + ${Title} {
        margin-top: 10px;
    }

    ${(props: LogoProps) => !props.isDefaultLogo && tillBreakpoint[MOBILE_MED]`max-width: 100%;`}
    ${(props: LogoProps) =>
        !props.isDefaultLogo &&
        fromBreakpoint[MOBILE_MED]`
        max-width: 279px;
    `}

    ${fromBreakpoint[TABLET]`
        & + ${Title} {
            margin-top: 10px;
        }
    `}
`;
